<template>
	<div style="padding: 20px 20px 20px 0;">
		<!-- tab页 -->
		<!-- <el-tabs v-model="selectForm.flag" @tab-click="getAll()">
			<el-tab-pane label="公寓" name="1"></el-tab-pane>
			<el-tab-pane label="商场" name="2"></el-tab-pane>
		</el-tabs> -->
		<!-- 搜索条件 -->
		<div>
			<el-form :inline="true" :model="selectForm" ref="selectForm">
				<el-form-item label="业主单位" prop="company">
					<el-select clearable style="width: 200px;" v-model="selectForm.company" filterable remote
						:loading="loading" placeholder="请输入单位名称" :remote-method="queryShopSearchAsync">
						<el-option v-for="(item, index) in shopList" :label="item.unitName" :value="item.deptId"
							:key="index">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="栋" prop="building">
					<el-input v-model="selectForm.building" placeholder="请输入栋"></el-input>
				</el-form-item>
				<el-form-item label="房间号" prop="roomNum">
					<el-input v-model="selectForm.roomNum" placeholder="请输入房间号"></el-input>
				</el-form-item>

				<el-form-item label="日期" prop="queryDate">
					<el-date-picker style="width: 100%" clearable v-model="queryDate" type="daterange" align="right"
						unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						:picker-options="pickerOptions" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAll">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="$refs.selectForm.resetFields(); query();">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="data" style="width: 100%">
			<el-table-column prop="company" label="业主单位" align="center"></el-table-column>
			<el-table-column prop="building" label="栋" align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.roomNum.split('幢')[0] }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="roomNum" label="房间号" align="center"></el-table-column>
			<el-table-column prop="price" label="单价" align="center"></el-table-column>
			<el-table-column prop="area" label="面积" align="center"></el-table-column>
			<el-table-column prop="userName" label="住户" align="center"></el-table-column>
			<el-table-column prop="userPhone" label="联系方式" align="center"></el-table-column>
			<el-table-column prop="month" label="金额(元/月)" align="center"></el-table-column>
			<el-table-column prop="year" label="金额(元/年)" align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.price * scope.row.area * 365 }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="userPhone" label="物业费期间" align="center"></el-table-column>
			<!-- <el-table-column prop="payNum" label="当期物业费" align="center"></el-table-column> -->
			<el-table-column prop="billPrice" label="应收物业费余额" align="center"></el-table-column>
			<!-- <el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="setRow(scope.row)">修改</el-button>
				</template>
			</el-table-column> -->
		</el-table>
		<!-- 分页 -->
		<el-pagination v-if="count > 0" @size-change="sizeChange" @current-change="currentChange"
			:current-page.sync="selectForm.pageNum"
			:page-sizes="[10, 20, 30, 40]" :page-size="selectForm.size" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum" style="margin-top: 10px;">
		</el-pagination>
	</div>
</template>

<script>
export default {
  data() {
    return {
      queryDate: [],
      loading: false,
      addList: {},
      count: 0,
      sum: 0,
      headerData: {
        Authorization: localStorage.access_token,
      },
      form: {
        //表单数据
        name: "",
        age: "",
      },
      oldForm: undefined, //表单备份数据
      data: [], //表格数据
      selectForm: {
        //查询条件
        pageNum: 1,
        pageSize: 10, //页大小
        building: "",
        type: "2", //1公寓 2商铺
        company: "",
        roomNum: "",
        startDate: null,
        endDate: null,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0, //数据总数
      show: false, //控制弹窗
      title: "",
      disable: false, //节流
      shopList: [],
      roomList: [],
      isChange: false,
      formData: {
        filePath: null,
        showPath: null,
        status: null,
      },
      rules: {
        status: [
          {
            required: true,
            message: "结清状态不能为空",
            trigger: ["blur", "change"],
          },
        ],
        // unitName: [{
        // 	required: true,
        // 	message: "单位名称不能为空",
        // 	trigger: ["blur", "change"]
        // }],
        property: [
          {
            required: true,
            message: "缴费模式不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      isXx: {},
      addShow: false,
    };
  },
  methods: {
    handleSelect(item) {
      console.log(item);
      console.log(this.selectForm.company);
    },
    // 查询所有单位信息
    clearShopSearch() {
      this.$refs.shopAutocomplete.handleFocus();
    },
    queryShopSearchAsync(query) {
      this.loading = true;
      this.$http
        .get("/api/ownerManage/getOwners?company=" + query)
        .then((res) => {
          console.log("查询所有单位信息", res);
          this.shopList = res.data.data;
          this.loading = false;
        });
    },
    // 解决el-autocomplete使用clearable，失效问题
    clearRoomSearch() {
      this.$refs.roomAutocomplete.handleFocus();
    },
    // goCheck(){
    goChange(e) {
      console.log(e);
      this.$http
        .get(`/api/wuye/pay/selectOneRoomMessage?roomNum=${e}`)
        .then((res) => {
          console.log(res);
          this.addList = res.data.data;
        });
    },
    goYes() {
      this.addList.year = parseInt(this.addList.time.split("-")[0]);
      this.addList.month = parseInt(this.addList.time.split("-")[1]);
      this.addList.time = null;
      // this.addList.year= new Date(this.addList.time).getFullYear()
      // this.addList.month=new Date(this.addList.time).getMonth()+1
      this.$http
        .post("/api/wuye/pay/insert", {
          ...this.addList,
          flag: "1",
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == -1) {
            this.$message.error(res.data.message);
          } else {
            this.addShow = false;
            this.$message.success(res.data.message);
            this.getAll();
          }
        });
    },
    getAdd() {
      this.addShow = true;
      this.$http.get("/api/wuye/pay/selectAllRoomMessage").then((res) => {
        console.log(res);
        this.roomList = res.data.data;
      });
    },
    confirmClick() {
      this.$refs.isXx.validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/wuye/pay/update", {
              ...this.isXx,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.isChange = false;
                this.getAll();
              }
              console.log(res);
            });
        } else {
          return;
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
      var isJPG = null;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        isJPG = true;
      } else {
        isJPG = false;
      }
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传Logo只能是 JPG/JPEG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isLt2M && isJPG;
    },
    handleAvatarSuccess2(file) {
      console.log(file);
      this.addList.filePath = file.data.filePath;
      this.addList.showPath = file.data.showPath;
    },
    // 上传成功
    handleAvatarSuccess(file) {
      console.log(file);
      this.isXx.filePath = file.data.filePath;
      this.isXx.showPath = file.data.showPath;
      console.log(this.formData);
    },
    handleClose2() {
      this.addShow = false;
    },
    handleClose() {
      this.isChange = false;
    },
    getYzList() {
      this.$http.get("/api/ownerManage/getOwners").then((res) => {
        console.log(res);
        this.yzlist = res.data.data;
      });
    },
    ok() {
      this.disable = true;
      let url = "/api/set";
      if (this.title[0] == "新") {
        url = "/api/add";
      }
      this.$http.post(url, this.form).then((res) => {
        this.disable = false;
        if (res.data.code == 0) {
          this.show = false;
          this.$message.success(`${this.title}成功`);
          this.getAll();
        } else {
          this.$message.error(`${this.title}失败`);
        }
      });
    },
    delRow(row) {
      //删除被点击
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(``, {
              id: row.id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                this.getAll();
              } else {
                this.$message.error("删除失败");
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    setRow(row) {
      //修改被点击
      this.isChange = true;
      this.isXx = row;
    },
    close() {
      //弹框关闭
      this.$refs.form.resetFields();
      this.form = JSON.parse(JSON.stringify(this.oldForm));
    },
    query() {
      this.queryDate = [];
      this.selectForm.pageNum = 1;
      this.getAll();
    },
    getAll() {
      //获取表格数据
      if (this.queryDate != null && this.queryDate.length == 2) {
        this.selectForm.startDate = this.queryDate[0];
        this.selectForm.endDate = this.queryDate[1];
      } else {
        this.selectForm.startDate = null;
        this.selectForm.endDate = null;
      }
      console.log("selectForm:", JSON.stringify(this.selectForm));
      this.$http
        .post(`/api/report/wuye/room/list`, {
          ...this.selectForm,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.data = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
            this.count = res.data.data.totalNum;
            this.loading = false;
          } else {
            this.data = [];
            this.totalNum = 0;
            this.count = 0;
            this.sum = 0;
          }
        });
    },
    sizeChange(size) {
      //页大小被修改
      this.selectForm.pageSize = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.pageNum = page;
      this.getAll();
    },
  },
  mounted() {
    this.oldForm = JSON.parse(JSON.stringify(this.form));
    // this.getYzList()
    this.getAll();
  },
};
</script>

<style>
</style>
